import styled from "styled-components";
import { CourseOptionViewModel } from "../../../../domain/viewmodels/report/CourseOptionViewModel";
import { StyledSearchableSelect } from "../../../creator/createCourse/CreateCourseStyles";

interface CourseMultiSelectDropdownProps {
    options: CourseOptionViewModel[];
    selectedIds: string[];
    onChange: (selectedIds: string[]) => void;
    onOpen?: () => void;
}

interface SelectOption {
    value: string;
    label: string;
}

export function CourseMultiSelectDropdown({
    options,
    selectedIds,
    onChange,
    onOpen
}: CourseMultiSelectDropdownProps) {

    const selectOptions: SelectOption[] = options.map(o => ({
        value: o.id,
        label: o.title,
    }));

    const selectedValues = selectOptions.filter(o => selectedIds.includes(o.value));

    const handleChange = (selected: any) => {
        const ids = selected ? (selected as SelectOption[]).map(s => s.value) : [];
        onChange(ids);
    };

    return (
        <SmallFontSelect
            className="react-select-container"
            classNamePrefix="react-select"
            isMulti
            options={selectOptions}
            value={selectedValues}
            onChange={handleChange}
            onMenuOpen={onOpen}
            placeholder="Selecione cursos"
            noOptionsMessage={() => "Nenhum curso disponível"}
        />
    );
}

const SmallFontSelect = styled(StyledSearchableSelect)`
    .react-select__placeholder,
    .react-select__single-value,
    .react-select__multi-value__label,
    .react-select__option,
    .react-select__input-container,
    .react-select__input {
        font-size: 0.85rem !important;
        line-height: 1.4 !important;
    }

    .react-select__value-container {
        height: auto;
        min-height: 38px;
    }

    .react-select__multi-value {
        font-size: 0.85rem !important;
    }
`;
